import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import BaseChart from '../BaseChart';
import useHighcharts from '../UseHighcharts';

var HighchartsChart = function HighchartsChart(props) {
  var Highcharts = useHighcharts();
  return /*#__PURE__*/React.createElement(BaseChart, _extends({}, props, {
    chartCreationFunc: Highcharts.chart,
    chartType: "chart"
  }));
};

export default HighchartsChart;